import {Enumeration} from 'Users/api';
import {LineOfBusinessValue} from './LineOfBusiness';

export enum Application {
  Portal = 1,
  Agent,
  BOSTools,
  Messaging,
  Quoting = 9,
}

export type ApplicationEnum = Enumeration;

export const mapLineOfBusinessToApplication = (lineOfBusinessValue: LineOfBusinessValue) => {
  switch (lineOfBusinessValue) {
    case 'agent':
      return Application.Agent;
    case 'bostools':
      return Application.BOSTools;
    case 'messaging':
      return Application.Messaging;
    case 'quoting':
      return Application.Quoting;
  }
};
